import React, { useEffect, useState } from "react";
import "./sections1.css";

import IndexxText from "../../../assets/indexx.ai_new.webp";
import IndexxTextLightMode from "../../../assets/indexxTextLightMode.webp";


import cryptoTreasury from "../../../assets/homepage/updated/treasury.svg";

/* Dark-mode product icons — assets/indexxNewIcons, all 120x120 squares.
   Light mode keeps the existing artwork. */
import bitcoinYayIconDark from "../../../assets/indexxNewIcons/bitcoinyayLogo.webp";
import cryptoTreasuryIconDark from "../../../assets/indexxNewIcons/CryptoTreasuryLogo.webp";
import emmmIconDark from "../../../assets/indexxNewIcons/EmmmLogo.webp";
import exchangeIconDark from "../../../assets/indexxNewIcons/ExchangeLogo.webp";
import usdxxIconDark from "../../../assets/indexxNewIcons/UsdxxLogo.webp";
import wallstreetIconDark from "../../../assets/indexxNewIcons/wallstreetLogo.webp";
import xTokensIconDark from "../../../assets/indexxNewIcons/XCryptoLogo.webp";
import yaysAppIconDark from "../../../assets/indexxNewIcons/YaysAppLogo.webp";


import updatedExchLightMode from "../../../assets/updated/homePage/exchangeLightMode.png";

import shop from "../../../assets/homepage/updated/shop.png";
import meme from "../../../assets/homepage/updated/meme.png";

import JacksAiLogo from "../../../assets/updated/homePage/jacksAiLogo.png";
import fantasyLottoLogo from "../../../assets/updated/homePage/fantasyLottoLogo.png";
import indexxPayLogo from "../../../assets/updated/homePage/indexxPayLogo.png";
import indexxWalletLogo from "../../../assets/updated/homePage/indexxWalletLogo.png";
import reHumanLabLogo from "../../../assets/updated/homePage/reHumanLabLogo.png";
import reHumanLabLogoDark from "../../../assets/updated/homePage/reHumanLabLogoDark.png";
import shoperPalLogo from "../../../assets/updated/homePage/shoperPalLogo.png";
import xxEmailLogo from "../../../assets/updated/homePage/xxEmailLogo.png";
import emmmmLogo from "../../../assets/updated/homePage/Emm_light.png";
import IndexxBigLogo from "../../../assets/updated/homePage/Indexx.aiUpdatedLogo.svg";
// import token from "../../../assets/homepage/token.png";
import tokenLightMode from "../../../assets/updated/homePage/tokenLightMode.png";

// import hive from "../../../assets/homepage/Hive icon.png";
import hive from "../../../assets/homepage/updated/hive.png";

import bitcoinyay from '../../../assets/logo.webp'

import yaysAppLightLogo from "../../../assets/homepage/updated/Yaysapplight-05.png";
import usdxxLogo from "../../../assets/homepage/updated/usdxx-removebg-preview.png";

import wisLogo from "../../../assets/homepage/updated/WIBS.svg";
import bitcoinyayLightMode from "../../../assets/updated/bitcoin-yay-light-mode.svg";
import bitcoinyayDarkMode from "../../../assets/updated/bitcoin-yay-dark-mode.svg";

import wisLogoLightMode from "../../../assets/updated/homePage/wibsLightMode.svg";
import wallstreetLogo from "../../../assets/updated/homePage/wallstreet_logo.png";

// import { Link } from "react-router-dom";
import {

  decodeJWT,
  getUserShortToken,
  baseNewCEXURL,
  baseBitcoinYayURL,
} from "../../../services/api";
// import { Button } from "antd";
import { Tooltip, Image } from "antd";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material";

const Section1 = () => {
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsAuthenticated(!!token);
  }, []);

  const isMobile = width <= 768;

  const handleNavigation = async (url: string) => {
    if (!url) return; // link not set yet
    const isAuthenticated = localStorage.getItem("access_token");

    const email = localStorage.getItem("email");
    //debugger;
    let shortToken;
    if (email) {
      shortToken = await getUserShortToken(email);
    } else if (isAuthenticated) {
      let decodedValue: any = await decodeJWT(isAuthenticated);
      shortToken = await getUserShortToken(decodedValue?.email);
    }

    if (isAuthenticated) {
      const urlWithToken = `${url}?signInToken=${shortToken?.data}`;
      //debugger;
      window.location.href = urlWithToken;
    } else {
      window.location.href = url;
    }
  };
  const theme = useTheme();
  return (
    <div className="home-containers">
      <div style={{ marginTop: "100px" }}></div>
      {/* <div
        className="home-main-container"
        style={{ position: "relative", zIndex: "1" }}
      >
        <div
          className="home-main-container-left"
          style={{
            flex: !isMobile ? "60%" : "100%",
          }}
        >
          <h1
            style={{
              textAlign: !isMobile ? "left" : "center",
              width: !isMobile ? "85%" : "100%",
              color: theme.palette.text.primary,
              fontSize: !isMobile ? "64px" : "42px",
            }}
          >
            {" "}
            Welcome to Indexx Where Your Crypto Journey Begins
          </h1>
        </div>
        {!isAuthenticated ? (
          <div className="home-main-container-right-new">
            <p style={{ color: theme.palette.text.primary }}>
              Sign In for the best experience
            </p>
            <div style={{ display: "flex", gap: 10 }}>
              <Link
                to="/auth/signup-email"
                style={{
                  color: theme.palette.text.primary,
                  marginTop: "10px",
                  flex: 1,
                  border: "1px solid #11BE6A",
                  padding: "10px 15px",
                  textAlign: "center",
                }}
                className="signOutHover"
              >
                Register
              </Link>
              <Link
                to="/auth/login"
                style={{
                  marginTop: "10px",
                  flex: 1,
                  background: "#11BE6A",
                  padding: "10px 15px",
                  textAlign: "center",
                  color: "black",
                }}
                className="signInHover"
              >
                Log in
              </Link>
            </div>
          </div>
        ) : (
          <></>

        )}
      </div> */}
      {/* <br /> */}

      <div
        className="conatiner-fluid d-flex justify-content-center flex-column "
        style={{
          maxWidth: "1100px",
          width: "100%",
          padding: "20px",
          margin: "0px auto -30px auto",
        }}
      >
        {/* <div className="home-main-container-right-feature">
          <p style={{ color: theme.palette.text.primary }}>
            Feature of the Month
          </p>
          <div className="feature-of-month-container">
            <div className="feature-of-month">
              <div
                onClick={() => handleNavigation("http://bitcoinyay.com/")}
                style={{
                  fontStyle: "italic",
                  color: "white",
                  marginTop: "10px",
                  display: `${isMobile ? "block" : "flex"}`,
                }}
              >
                <span>
                  <img
                    src={
                      theme.palette.mode === "dark"
                        ? bitcoinyayDarkMode
                        : bitcoinyayLightMode
                    }
                    height="140px"
                  />
                </span>
              </div>
            </div>{" "}
            <div
              className="daCrazyContainer"
              onClick={() =>
                handleNavigation("https://whoisbitcoinsatoshi.wtf/")
              }
            >
              <img
                alt="Sorekt logo"
                style={{ width: "400px" }}
                src={theme.palette.mode === "dark" ? wisLogo : wisLogoLightMode}
              />
            </div>
          </div>
        </div> */}

        {/* place a image in the center */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "50px" }}>
          <img src={IndexxBigLogo} alt="" />

        </div>
        <div
          style={{
            display: isMobile ? "none" : "flex",
            justifyContent: "center",
            marginBottom: "10px",
            marginTop: "80px",
          }}
        >
          <img
            src={
              theme.palette.mode === "dark" ? IndexxText : IndexxTextLightMode
            }
            alt="Indexx Logo"
            className="center-Image"
            style={{ height: "50px" }}
          />

        </div>
        <div className="text-2xl font-bold" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "50px" }}>
          <p className="text-2xl font-bold">The Ecosystem of AI and Crypto</p>
        </div>
        <div className={`${isMobile ? "d-block" : "d-flex mt-8"} mx-2`} style={{ marginTop: isMobile ? "80px" : "20px" }}>
          <div className="abc">
            <div
              onClick={() => handleNavigation(baseBitcoinYayURL)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={
                  theme.palette.mode === "dark"
                    ? bitcoinYayIconDark
                    : bitcoinyay
                }
                alt="bitcoin yay"
                height="60px"
              />

              <span className="desc">Bitcoin Yay</span>
              <span className="desc2">
                Bitcoin Yay Is The Micro Token
                And Petty Cash Of Bitcoin
              </span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() =>
                handleNavigation("https://cex.indexx.ai/crypto-treasury")
              }
              style={{ cursor: "pointer" }}
            >
              <img
                src={
                  theme.palette.mode === "dark"
                    ? cryptoTreasuryIconDark
                    : cryptoTreasury
                }
                height="60px"
                alt="indexx ai trading"
              />

              <span className="desc">Crypto Treasury</span>
              <span className="desc2">
                Drives crypto value through security, innovation, and growth.
              </span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://eenymeenyminymoe.io/")}
              style={{ cursor: "pointer" }}
            >
              <img src={theme.palette.mode === "dark"
                ? emmmIconDark : emmmmLogo} alt="eeny meeny miny moe" height="60px" />

              <span className="desc"> Eeny Meeny Miny Moe</span>
              <span className="desc2">
                Eeny Meeny Miny Moe premium global prediction market.
              </span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation(baseNewCEXURL)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={
                  theme.palette.mode === "dark"
                    ? exchangeIconDark
                    : updatedExchLightMode
                }
                height="60px"
              />

              <span className="desc">Exchange</span>
              <span className="desc2">
                Crypto Exchange where you Buy/Sell and Convert Crypto Currencies
              </span>
            </div>
          </div>
        </div>

        <div className={`${isMobile ? "d-block" : "d-flex"} mx-2 mt-4`}>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://lotto.indexx.ai/")}
              style={{ cursor: "pointer" }}
            >
              <img src={fantasyLottoLogo} alt="fantasy lotto" height="60px" />

              <span className="desc">Fantasy Lotto</span>
              <span className="desc2">A Crypto based lottery where you can earn big rewards.</span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://pay.indexx.ai/")}
              style={{ cursor: "pointer" }}
            >
              <img src={indexxPayLogo} alt="indexx pay" height="60px" />

              <span className="desc">Indexx Pay</span>
              <span className="desc2">A digital payment platform powered by USDXX, enabling simple, secure, and seamless payments within the Indexx ecosystem.</span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://wallet.indexx.ai/")}
              style={{ cursor: "pointer" }}
            >
              <img src={indexxWalletLogo} alt="indexx wallet" height="60px" />

              <span className="desc">Indexx Wallet</span>
              <span className="desc2">A secure digital asset wallet for managing, storing, and accessing crypto assets within the Indexx ecosystem.</span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation("http://jackai.si/")}
              style={{ cursor: "pointer" }}
            >
              <img
                className="aiainai"
                src={JacksAiLogo}
                alt="Jack's AI"
                height="60px"
              />

              <span className="desc">Jack's AI</span>
              <span className="desc2">
                God's Perspective AI gateway. Your personal assistant powered by every AI.
              </span>
            </div>
          </div>
        </div>

        <div className={`${isMobile ? "d-block" : "d-flex"} mx-2 mt-4`}>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://rehumenlab.com/")}
              style={{ cursor: "pointer" }}
            >
              <img src={theme.palette.mode === "dark" ? reHumanLabLogoDark : reHumanLabLogo} alt="rehuman lab" height="60px" />

              <span className="desc">ReHumen Lab</span>
              <span className="desc2">Advancing human longevity through regenerative wellness and science.</span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://test.shoperpal.com/")}
              style={{ cursor: "pointer" }}
            >
              <img src={shoperPalLogo} alt="shoperpal" height="60px" />

              <span className="desc">ShoperPal</span>
              <span className="desc2">AI-powered shopping companion designed to make product discovery and online shopping simpler and smarter.</span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://usdxxlynx.com")}
              style={{ cursor: "pointer" }}
            >
              <img
                src={
                  theme.palette.mode === "dark" ? usdxxIconDark : usdxxLogo
                }
                alt="usdxx"
                height="60px"
              />

              <span className="desc"> USDXX</span>
              <span className="desc2">
                A digital finance platform built around USDXX for seamless digital asset transactions and financial services.
              </span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://wallstreet.indexx.ai/")}
              style={{ cursor: "pointer" }}
            >
              {theme.palette.mode === "dark" ? (
                <img
                  src={wallstreetIconDark}
                  height="60px"
                  alt="indexx wallstreet"
                />
              ) : (
                <img
                  src={wallstreetLogo}
                  height="35px"
                  alt="indexx wallstreet"
                  style={{
                    filter: "invert(1)",
                    marginBottom: "15px",
                    marginTop: 10
                  }}
                />
              )}

              <span className="desc"> Wallstreet</span>
              <span className="desc2">
                Market Exchange for Small Businesses.
              </span>
            </div>
          </div>
        </div>

        <div className={`${isMobile ? "d-block" : "d-flex"} mx-2 mt-4`}>
          <div className="abc">
            <div
              onClick={() =>
                handleNavigation(
                  "/xtokens"
                )
              }
              style={{ cursor: "pointer" }}
            >
              <img
                src={
                  theme.palette.mode === "dark" ? xTokensIconDark : tokenLightMode
                }
                height="60px"
              />

              <span className="desc"> xTokens</span>
              <span className="desc2">
                Dive into all the tokens made by Indexx.ai
              </span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://test.xxemail.com/")}
              style={{ cursor: "pointer" }}
            >
              <img src={xxEmailLogo} alt="xxemail" height="60px" />

              <span className="desc">XXEmail</span>
              <span className="desc2">A modern email platform designed for simple, secure, and efficient digital communication.</span>
            </div>
          </div>
          <div className="abc">
            <div
              onClick={() => handleNavigation("https://web.yaysapp.com")}
              style={{ cursor: "pointer" }}
            >
              <img
                src={
                  theme.palette.mode === "dark"
                    ? yaysAppIconDark
                    : yaysAppLightLogo
                }
                alt="yaysapp"
                height="60px"
              />

              <span className="desc">YaysApp</span>
              <span className="desc2">
                A social and community platform for connecting, sharing, and engaging within the Yay ecosystem.
              </span>
            </div>
          </div>
          <div className="abc"></div>
        </div>

      </div>
    </div>
  );
};

export default Section1;
